//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import Button from "@material-ui/core/Button";
import GetAppIcon from "@material-ui/icons/GetApp";

import UploadFileWithConfigurationButton from "src/components/loader/buttons/UploadFileWithConfigurationButton";

const ClearXerButton = (props) => {
    return (
        <UploadFileWithConfigurationButton
            label="Clean Up XER"
            url="loader/cleanupFile"
            icon={<GetAppIcon />}
            {...props}
        />
    );
};
export default ClearXerButton;